import { getVigboUrl } from 'reactApp/modules/vigbo/vigbo.helpers';
import { getCurrentVigboAlbum } from 'reactApp/modules/vigbo/vigbo.selectors';
import { store as reduxStore } from 'reactApp/store';
import opener from 'reactApp/utils/opener';

export const watchVigboGallery = () => {
    const state = reduxStore.getState();
    const vigboAlbum = getCurrentVigboAlbum(state);

    if (!vigboAlbum) {
        return;
    }

    const params = { album_id: vigboAlbum.id };
    const watchVigboGallery = getVigboUrl('watchVigboGallery', params);
    if (!watchVigboGallery) {
        return;
    }

    opener(watchVigboGallery);
};
